import { GetterTree } from "vuex";
import { IComponentState } from "./state";
import { IComponent, ISearchComponent } from "@/models";

export const getters: GetterTree<IComponentState, any> = {
    getSearchComponents: (state) => (): /*ISearchComponent[]*/ IComponent[] => {
        return state.searchComponents;
    },
};
